"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../theme/makeStyles");
var INPUT_SIZE = 20;
var INPUT_CIRCLE_SIZE = 10;
var INPUT_CIRCLE_MARGIN = INPUT_CIRCLE_SIZE / 2;
exports.default = (0, makeStyles_1.makeStyles)(function (theme) { return ({
    root: {
        display: 'inline-flex',
        flexDirection: 'row',
        minHeight: 48
    },
    labelText: {
        cursor: 'pointer'
    },
    input: {
        appearance: 'none',
        backgroundColor: theme.colors.white,
        border: "2px solid ".concat(theme.colors.gray300),
        borderRadius: '50%',
        cursor: 'pointer',
        flexGrow: 0,
        flexShrink: 0,
        height: INPUT_SIZE,
        marginTop: 2,
        marginRight: 10,
        position: 'relative',
        transition: 'all .2s ease-in-out',
        width: INPUT_SIZE,
        '&::before': {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            borderRadius: '50%',
            content: '""',
            height: INPUT_CIRCLE_SIZE,
            left: '50%',
            marginLeft: -INPUT_CIRCLE_MARGIN,
            marginTop: -INPUT_CIRCLE_MARGIN,
            position: 'absolute',
            top: '50%',
            transition: 'all .2s ease-in-out',
            width: INPUT_CIRCLE_SIZE
        },
        '&:disabled': {
            borderColor: theme.colors.gray300,
            cursor: 'not-allowed',
            '&:checked': {
                '&::before': {
                    backgroundColor: theme.colors.gray300
                }
            },
            '& + $labelText': {
                cursor: 'not-allowed',
                '& > *': {
                    color: theme.colors.gray300
                }
            }
        },
        '&:enabled': {
            '&:hover': {
                borderColor: theme.colors.gray400
            },
            '&:checked': {
                borderColor: theme.colors["".concat(theme.colorFamily.forms, "400")],
                '&::before': {
                    backgroundColor: theme.colors["".concat(theme.colorFamily.forms, "400")]
                },
                '&:hover': {
                    borderColor: theme.colors["".concat(theme.colorFamily.forms, "500")],
                    '&::before': {
                        backgroundColor: theme.colors["".concat(theme.colorFamily.forms, "500")]
                    }
                }
            }
        }
    },
    error: {
        borderColor: theme.colors.warningAccessible
    }
}); });
